export const isOvertimeRequestPending = (request) => {
  if (request.overtimeRequest && request.status === "PENDING") {
    return true;
  }
  return false;
};
